import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "@fortawesome/fontawesome-free/css/all.css";
import ErrorBoundary from "./pages/ErrorBoundary";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import React, { createContext, useContext, useState } from "react";
import { MySnackBarContext } from "./components/MySnackBar";

import { AlertContext } from "./contexts/AlertContext";
import MainRoutes from "./routes";

export const RefreshContext = createContext();
function App() {
  const [alertData, setAlertData] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const [refresh, setRefresh] = useState(false);
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AlertContext.Provider value={{ alertData, setAlertData }}>
          <RefreshContext.Provider value={{ refresh, setRefresh }}>
            <MainRoutes />
            <MySnackBarContext
              alertData={alertData}
              setAlertData={setAlertData}
            />
          </RefreshContext.Provider>
        </AlertContext.Provider>
      </LocalizationProvider>
    </>
  );
}

export default App;
